<template>
  <div class="select-field">
    <div
      class="select-field__value"
      :class="{
        'select-field__value--opened': isOpened
      }"
      @click="isOpened = !isOpened"
    >
      {{ value }}
    </div>
    <div
      class="select-field__values"
      :class="{
        'select-field__values--visible': isOpened
      }"
    >
      <template v-for="val in VALUES">
        <div
          class="select-field__values-item"
          :class="{
            'select-field__values-item--selected': value === val
          }"
          :key="val"
          @click="$emit('value-changed', val); isOpened = false"
        >
          {{ val }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export const VALUES = {
  yesterday: 'Yesterday',
  week: '7 Days',
  month: '30 Days',
};

export default {
  props: {
    value: { type: String, required: true },
  },
  data: () => ({
    VALUES,
    isOpened: false,
  }),
};
</script>

<style lang="scss" scoped>
.select-field {
  position: relative;
}
.select-field__value {
  font-size: 14px;
  line-height: 17px;
  color: #0A2756;
  font-weight: 500;
  position: relative;
  padding-right: 18px;
  width: 82px;
  box-sizing: border-box;
  cursor: pointer;

  &:after {
    content: '';
    position: absolute;
    top: 7px;
    width: 0;
    height: 0;
    right: 0;
    border-style: solid;
    border-width: 6px 6px 0 6px;
    border-color: #0080FF transparent transparent transparent;
  }
  &--opened:after {
    transform: rotate(180deg);
  }
}
.select-field__values {
  opacity: 0;
  visibility: hidden;
  position: absolute;
  top: calc(100% + 8px);
  left: -12px;
  right: 0;
  background-color: #fff;
  z-index: 1;
  display: block;
  padding: 4px 0;
  border-radius: 4px;
  box-shadow: 0 4px 12px 0 rgb(235, 238, 241);
  transition: .3s ease-out;

  &--visible {
    visibility: visible;
    opacity: 1;
  }
}
.select-field__values-item {
  font-size: 14px;
  line-height: 17px;
  padding: 8px 12px;
  color: #0A2756;
  font-weight: 500;
  cursor: pointer;
  transition: .3s ease-out;

  &--selected {
    background-color: #E3E6EA;
  }

  &:hover {
    background-color: #E3E6EA;
  }
}
</style>
